import { createContext, useContext, type ReactNode } from 'react';

// Holds the top-bar page-header segment element so PageHeader can portal into it
// on tablet+. Null on mobile (and during the first render before the ref mounts).
const PageHeaderSlotContext = createContext<HTMLElement | null>(null);

export const PageHeaderSlotProvider = PageHeaderSlotContext.Provider;

// eslint-disable-next-line react-refresh/only-export-components
export const usePageHeaderSlot = (): HTMLElement | null => useContext(PageHeaderSlotContext);

// Generic global header actions (e.g. the notification bell). Provided by AppShell
// so PageHeader can render them at the far right without importing any feature.
const HeaderActionsContext = createContext<ReactNode>(null);

export const HeaderActionsProvider = HeaderActionsContext.Provider;

// eslint-disable-next-line react-refresh/only-export-components
export const useHeaderActions = (): ReactNode => useContext(HeaderActionsContext);
